<template>
  <div class="slideout-link-search">
    <label>Search</label>
    <form class="slideout-link-search-form" v-on:submit.prevent>
      <b-input placeholder="Enter Search Terms" v-model="search" />
      <div class="radio-buttons">
        <b-radio v-model="whichSearch" native-value="global">
          All Getty
        </b-radio>
        <b-radio v-model="whichSearch" native-value="collection">
          Museum Collection
        </b-radio>
        <b-radio v-model="whichSearch" native-value="gci">
          Conservation Institute
        </b-radio>
      </div>
      <b-button @click="routeSearch">Search</b-button>
      <b-button @click="closeSlideout">Close Menu</b-button>
    </form>
  </div>
</template>

<script>
export default {
  name: "SlideoutForm",
  data() {
    return {
      search: "",
      whichSearch: "global"
    };
  },
  computed: {
    whichSearchPage() {
      if (this.whichSearch === "collection") {
        return "/art/collection/search/";
      } else if (this.whichSearch === "gci") {
        return "/search/gci/results";
      } else {
        return "/search/global/";
      }
    }
  },
  props: {
    open: Boolean
  },
  methods: {
    closeSlideout() {
      this.$parent.$emit("update:close:menu");
    },
    routeSearch() {
      this.$router.push({
        path: this.whichSearchPage,
        query: {
          qt: this.search,
          pg: 1
        }
      });
      this.search = "";
      this.$parent.$emit("update:close:menu");
    }
  }
};
</script>

<style lang="scss" scoped>
.slideout-link-search {
  color: $white;
  font-size: 0.8125em;
  font-weight: 800;
  padding: 0 0.5em;
  text-align: left;
  label {
    text-transform: uppercase;
    padding-left: 0.45em;
  }
  &-form {
    .radio-buttons {
      margin: 1em 0;
    }
    .field {
      .has-addon {
        display: block;
      }
    }
  }
  .radio {
    margin-left: 0.5em;
    width: 100%;
    text-transform: none;
    &:hover {
      color: $grey-lighter;
    }
  }
}
</style>
